import styled from '../../../styles/styled';
import { Box } from '../../layout';
export const ErrorContainer = styled(Box)(({ theme }) => ({
    border: '1px solid transparent',
    justifyContent: 'flex-start',
    width: '100%',
    minHeight: '34px',
}));
export const InputValidationError = styled(Box)(({ theme }) => ({
    borderRadius: '2px',
    marginLeft: '4px',
    backgroundColor: 'transparent',
    fontFamily: theme.text.bodyFontFamily,
    fontSize: theme.text.size.small,
    width: '100%',
    height: '100%',
}));
//# sourceMappingURL=form_validation.js.map